import React from "react";
import ConnectionsScreen from "../components/connections/ConnectionsScreen";

export default function ConnectionsPage() {
  return <ConnectionsScreen />;
}
